export default "__VITE_ASSET__94421e2c__"